module.exports = __webpack_public_path__ + "static/media/manual-transmission.2844523d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/CarPage/images/manual-transmission.svg
// module id = 550
// module chunks = 0